export default "__VITE_ASSET__Ch9hZkKz__"